import { Controller, useForm } from 'react-hook-form'
import { AddressEditFormProps } from './types'
import { AddressCreateModel, AddressModel } from 'shared/models'
import { Box, Button, Card, Tab, TextField } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'
import { getValidations } from './validation'
import { IntlPhoneInput } from 'features/intl-phone-input'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { useState } from 'react'

function AddressEditForm({ defaultData, onSubmit, isProcess, onDelete, isEdit }: AddressEditFormProps) {
  const [isDeleting, setIsDeleting] = useState(false)

  const { control, handleSubmit } = useForm<AddressModel | AddressCreateModel>({
    defaultValues: defaultData,
    disabled: isProcess,
    resolver: yupResolver<AddressModel | AddressCreateModel>(getValidations())
  })

  function handleDelete() {
    setIsDeleting(true)
  }

  function cancelDelete() {
    setIsDeleting(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Card elevation={1}>
        <TabContext value="main">
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList>
              <Tab label="Основная информация" value="main" />
            </TabList>
          </Box>
          <TabPanel value="main">
            <Controller
              control={control}
              name="address"
              defaultValue=""
              render={({ field, fieldState }) => (
                <TextField
                  label="Адрес"
                  fullWidth
                  autoComplete="off"
                  placeholder="Адрес"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={isProcess}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="none"
                />
              )}
            />
            <Controller
              control={control}
              name="city"
              defaultValue=""
              render={({ field, fieldState }) => (
                <TextField
                  label="Город"
                  fullWidth
                  placeholder="Город"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={field.disabled}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="dense"
                />
              )}
            />
            <Controller
              control={control}
              name="latitude"
              render={({ field, fieldState }) => (
                <TextField
                  label="Широта"
                  fullWidth
                  placeholder="Широта"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  type="number"
                  onBlur={field.onBlur}
                  disabled={field.disabled}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="dense"
                />
              )}
            />
            <Controller
              control={control}
              name="longitude"
              render={({ field, fieldState }) => (
                <TextField
                  label="Долгота"
                  fullWidth
                  placeholder="Долгота"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  type="number"
                  onBlur={field.onBlur}
                  disabled={field.disabled}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="dense"
                />
              )}
            />
            <Controller
              control={control}
              name="phone"
              render={({ field, fieldState }) => (
                <IntlPhoneInput
                  label="Номер телефона"
                  fullWidth
                  placeholder="Номер телефона"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={field.disabled}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  margin="dense"
                />
              )}
            />
            <Controller
              control={control}
              name="email"
              render={({ field, fieldState }) => (
                <TextField
                  label="Email адрес для уведомлений"
                  fullWidth
                  placeholder="Email адрес для уведомлений"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={field.disabled}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  ref={field.ref}
                  margin="dense"
                />
              )}
            />
          </TabPanel>
        </TabContext>
      </Card>
      {!isDeleting && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: '1rem' }}>
          {isEdit && (
            <Button onClick={handleDelete} disabled={isProcess}>
              Удалить
            </Button>
          )}
          <Button type="submit" variant="outlined" disabled={isProcess}>
            Сохранить
          </Button>
        </Box>
      )}
      {isDeleting && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 3, gap: '1rem' }}>
          Вы действительно хотите удалить адрес?
          <Button onClick={cancelDelete} disabled={isProcess}>
            Отмена
          </Button>
          <Button variant="outlined" color="error" disabled={isProcess} onClick={onDelete}>
            Удалить
          </Button>
        </Box>
      )}
    </form>
  )
}

export { AddressEditForm }
